const FEED_LINK_SELECTOR = 'a[href^="/feed/"]';
const TOPIC_LINK_SELECTOR = 'a[href^="/topics/"]';
const TOPIC_DETAIL_PATH = /^\/topics\/(?!following(?:\/|$))[a-z0-9-]+\/?$/i;

function feedFromContext() {
  const { pathname } = window.location;
  if (pathname === '/home') return 'home';

  const stockMatch = pathname.match(/^\/stocks\/([^/]+)/i);
  return stockMatch ? stockMatch[1].toLowerCase() : null;
}

function withFromParam(href, from) {
  if (!href || href.includes('from=')) return href;

  const separator = href.includes('?') ? '&' : '?';
  return `${href}${separator}from=${encodeURIComponent(from)}`;
}

function patchFeedLinks(root = document) {
  const from = feedFromContext();
  if (!from) return;

  root.querySelectorAll(FEED_LINK_SELECTOR).forEach((link) => {
    const href = link.getAttribute('href');
    const nextHref = withFromParam(href, from);
    if (nextHref && nextHref !== href) {
      link.setAttribute('href', nextHref);
    }
  });
}

function patchTopicLinks(root = document) {
  if (window.location.pathname !== '/home') return;

  root.querySelectorAll(TOPIC_LINK_SELECTOR).forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const path = href.split('?')[0];
    if (!TOPIC_DETAIL_PATH.test(path)) return;

    const nextHref = withFromParam(href, 'home');
    if (nextHref !== href) {
      link.setAttribute('href', nextHref);
    }
  });
}

function observeFeedLinks() {
  patchFeedLinks();
  patchTopicLinks();

  if (!document.body) return;

  const observer = new MutationObserver(() => {
    patchFeedLinks();
    patchTopicLinks();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeFeedLinks);
} else {
  observeFeedLinks();
}
